import React from "react";

const Header = () =>{
    return(
        <div>
            <h1>Expense Tracker</h1>
        </div>
    )
}

export default Header;